<template>
   <div class="resource-card" :class="`volunteer-card__${state}`">
        <CardContentLoader v-if="state === 'loading'" />

        <ResourceCard
            v-else
            :id="volunteer.slug || volunteer.id"
            :badge-main="badgeMain ? badgeMainData : null"
            badge-text="Dobrovoľník"
            button-text="Viac o mne"
            :heading="fullName"
            :image="volunteer.profileImg"
            image-type="volunteer"
            :pills="interests"
            :preview="preview"
            :return-route="returnRoute"
            :search-tag-query-param="searchTagQueryParam"
            :search-tag-route-name="searchTagRouteName"
            :sub-heading="currentJob"
            :tags-max-count="5"
            :to="{
                name: 'dobrovolnictvo-dobrovolnici-id',
                params: { id: volunteer.slug || volunteer.id }
            }"
        >
            <IconTextRow v-if="location" class="-mb-1" icon="location-outline" slim>
                {{ location }}
            </IconTextRow>
        </ResourceCard>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import orderBy from 'lodash-es/orderBy'

import { BadgeMainType } from '#shared/types/Badge'
import { UserProfile } from '#shared/types/User'
import { getFullName } from '#shared/utils'
import CardContentLoader from '@/components/common/CardContentLoader.vue'
import IconTextRow from '@/components/common/IconTextRow.vue'
import ResourceCard from '@/components/common/ResourceCard.vue'
import { useUser } from '@/composables/user/useUser'

export default defineComponent({
  name: 'VolunteerCard',

  components: {
    CardContentLoader,
    IconTextRow,
    ResourceCard
  },

  props: {
    volunteer: {
      type: Object as PropType<UserProfile>,
      required: true
    },
    returnRoute: {
      type: Object as PropType<any>,
      default: undefined
    },
    searchTagRouteName: {
      type: String,
      default: 'dobrovolnictvo-dobrovolnici'
    },
    searchTagQueryParam: {
      type: String,
      default: 'interests'
    },
    loading: Boolean,
    badgeMain: Boolean,
    preview: Boolean
  },

  setup(props) {
    const badgeMainData = computed<BadgeMainType>(() => ({
      text: 'Dobrovoľníctvo',
      color: 'purple'
    }))

    const state = computed(() => (props.loading ? 'loading' : 'idle'))

    const currentJob = computed(() =>
      orderBy(props.volunteer?.jobs ?? [], 'endYear', 'desc')[0]?.position
    )

    const interests = computed(() => props.volunteer?.volunteerProfile?.interests ?? [])

    const { formatLocation } = useUser()
    const location = computed(() => formatLocation(props.volunteer))

    const fullName = computed(() => getFullName(props.volunteer))

    return {
      badgeMainData,
      state,
      currentJob,
      interests,
      location,
      fullName
    }
  }
})
</script>